import { makeActionCreator } from '../../../config/store/utils';
import { readAnomaliesVolvo } from '../../../services/productivityService'; // Assuming the function is in this service file

// Action Types
export const GET_ANOMALIES_VOLVO = 'GET_ANOMALIES_VOLVO';
export const GET_ANOMALIES_VOLVO_ERROR = 'GET_ANOMALIES_VOLVO_ERROR';
export const GET_ANOMALIES_VOLVO_SUCCESS = 'GET_ANOMALIES_VOLVO_SUCCESS';

// Action Creators
export const onGetAnomaliesVolvo = makeActionCreator(GET_ANOMALIES_VOLVO);
export const onGetAnomaliesVolvoError = makeActionCreator(
  GET_ANOMALIES_VOLVO_ERROR,
  'payload'
);
export const onGetAnomaliesVolvoSuccess = makeActionCreator(
  GET_ANOMALIES_VOLVO_SUCCESS,
  'payload'
);

// Async action to fetch the Parquet data
export const onGetAnomaliesVolvoThunk = ({
  year,
  month,
  day,
}) => async dispatch => {
  dispatch(onGetAnomaliesVolvo()); // Start loading
  try {
    const type = 'ml-anomalies-volvo'; // Adjust the type if necessary
    const response = await readAnomaliesVolvo({ type, year, month, day });

    const { anomalies = [], geofence_anomalies = [] } = response.data;

    // Add IDs to each item
    const anomaliesData = anomalies.map((item, index) => ({
      ...item,
      id: `anomaly-${index + 1}`,
    }));

    const geofenceData = geofence_anomalies.map((item, index) => ({
      ...item,
      id: `geofence-${index + 1}`,
    }));

    // Dispatch success with both datasets
    dispatch(
      onGetAnomaliesVolvoSuccess({
        data: anomaliesData,
        geofenceAnomalies: geofenceData,
      })
    );
  } catch (error) {
    console.log(error);
    dispatch(
      onGetAnomaliesVolvoError({
        error: error.message || 'Error fetching data',
      })
    ); // Dispatch error
  }
};
